import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { User, UserReset, UserChangePass, ConfirmaMailParams } from './user.model';
import { environment } from '../../environments/environment';
import {PlatformLocation } from '@angular/common';

@Injectable()
export class UserService {
  readonly rootUrl = environment.API_URL;
  constructor(private http: HttpClient ,
    platformLocation: PlatformLocation) {
      if (environment.production) {
        this.rootUrl = (platformLocation as any).location.origin + environment.API_URL ;
      }
      console.log((platformLocation as any).location.origin + environment.API_URL);
      console.log(this.rootUrl);
      // console.log((platformLocation as any).location);
      // console.log((platformLocation as any).location.href);
      // console.log((platformLocation as any).location.origin);
    }

  registerUser(user: User) {
    const body: User = {
      ConfirmPassword: user.ConfirmPassword,
      UserName: user.UserName,
      Password: user.Password,
      Email: user.Email,
      FirstName: user.FirstName,
      LastName: user.LastName,
      clienteID: user.clienteID,
      Empresa: user.Empresa
    };
    const reqHeader = new HttpHeaders({'No-Auth': 'True'});
    // console.log('en user register');
    // console.log(body);
    // console.log(this.rootUrl + '/api/Account/Register');

    return this.http.post(this.rootUrl + '/api/Account/Register', body, {headers : reqHeader});
  }
  updateUser(user: User) {
    const body: User = {
      ConfirmPassword: user.ConfirmPassword,
      UserName: user.UserName,
      Password: user.Password,
      Email: user.Email,
      FirstName: user.FirstName,
      LastName: user.LastName,
      clienteID: user.clienteID,
      Empresa: user.Empresa
    };
    const reqHeader = new HttpHeaders({'No-Auth': 'True'});
    // console.log('en user register');
    // console.log(body);
    // console.log(this.rootUrl + '/api/Account/Register');
    return this.http.post(this.rootUrl + '/api/Account/Register', body, {headers : reqHeader});
  }
  userAuthentication(userName, password, recaptchaStr) {
    const data = 'username=' + userName + '&password=' + password + '&g-recaptcha-response=' + recaptchaStr  + '&grant_type=password';
    const reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'No-Auth': 'True' });
    // application/x-www-urlencoded; charset=UTF-8
    // console.log('en user auth');
    return this.http.post(this.rootUrl + '/token', data, { headers: reqHeader });
  }

  getUserClaims() {
    const reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded' });
    // console.log('en user claims');
   return  this.http.get(this.rootUrl + '/api/Account/UserInfo'); // GetUserClaims { headers: reqHeader }
  }

  // GET: /Account/ConfirmEmail
  ConfirmEmail(userId, code) {
    const confmail: ConfirmaMailParams = {
      code: code,
      userId: userId
    };
    // const data = 'userId=' + userId + '&code=' + code ;
    // const reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'No-Auth': 'True' });
    console.log('confirm mail');
    return this.http.post(this.rootUrl + '/api/Account/ConfirmUser', confmail); //  data, { headers: reqHeader });
  }

  // POST: /Account/ForgotPassword
  ForgotPassword(userId) {
    const data = 'Email=' + userId  ;
    const reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'No-Auth': 'True' });
    console.log('ForgotPassword');
    return this.http.post(this.rootUrl + '/api/Account/ForgotPassword', data, { headers: reqHeader });
  }

  // POST: /Account/ResetPassword  [ValidateAntiForgeryToken]
  ChangePassword(user: UserChangePass) {
    const userreste: UserChangePass = {
      OldPassword: user.OldPassword,
      ConfirmPassword: user.ConfirmPassword,
      NewPassword: user.NewPassword
    };
    // const reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded' });
    // const reqHeader = new HttpHeaders({'No-Auth': 'True'});
    // console.log('en user register');
    // console.log(body);
    // console.log(this.rootUrl + '/api/Account/Register');
    return this.http.post(this.rootUrl + '/api/Account/ChangePassword', userreste); // , {headers : reqHeader}
  }

  // POST: /Account/ResetPassword  [ValidateAntiForgeryToken]
  ResetPassword(user: UserReset) {
    const userreste: UserReset = {
      Code: user.Code,
      ConfirmPassword: user.ConfirmPassword,
      UserName: user.UserName,
      Password: user.Password
    };
    const reqHeader = new HttpHeaders({'No-Auth': 'True'});
    // console.log('en user register');
    // console.log(body);
    // console.log(this.rootUrl + '/api/Account/Register');
    return this.http.post(this.rootUrl + '/api/Account/ResetPassword', userreste, {headers : reqHeader});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/user.service.ts